<template>
    <section class="font-poppins flex md:flex-col">
        <div>
            <AdminDashboardNav/>
        </div>
        <div class="w-screen p-2 md:pl-1 md:pr-1">
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col-reverse">
                    <div class="md:mt-6">
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-lg">MANAGE CARRIERS</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>
            <section>

                <section class=" mt-10">
                    <div class="text-sm flex justify-end md:flex-col">
                        
                        <div>
                            <input v-model="searchQuery" @click="search = !search" class="border outline-none w-72 p-2 rounded-lg bg-gray-100 text-xs" type="text" name="search" id="search" placeholder="Search name, email...">
                            <i class="fa fa-search -ml-8 md:hidden"></i>
                            
                        </div>
                    </div>
                </section>
                    <div>
                        <button class=" ml-4 text-blue-700 cursor-pointer md:mt-4" @click="goBack" ><i class="fa fa-arrow-left mr-2"></i>Go Back</button>
                        <router-link to="/approved-riders" class="text-blue-600 border ml-4 p-2">Approved Carriers</router-link>
                    </div>
                
                <div class="mt-6">
                    <div class="font-bold text-xl pb-4 flex">
                        <p>Pending Approvals</p> 
                        <i v-if="isLoading" class="fa  fa-spinner fa-spin  ml-4 text-blue-600"></i>    
                    </div>

                </div>
                

                <div class="text-sm md:overflow-x-auto">
                    <table class="w-full mt-5">
                        <tbody>
                            <tr class="text-left border-b-2">
                                <th>Name</th>
                                <th>Email</th>
                                <th>Gender</th>
                                <th>Plate No</th>
                                <th>Attachment(s)</th>
                                <th>Status</th>
                                <th>Reg Date</th>
                            </tr>
                            
                            <tr v-for="rider in filterName" :key="rider.riderId" class="hover:bg-gray-300 hover:border border-l-2 hover:border-blue-700 border-b-2">
                                <td>{{rider.firstName}} {{rider.lastname}}</td>
                                <td class="text-blue-700 p-1">{{rider.email}}</td>
                                <td>{{rider.gender}}</td>
                                <td>{{rider.licenseNumber}}</td>
                                <td class=" text-blue-500"> <span class="fa fa-link mr-1"></span>{{rider.filesCount}} files</td>
                                <td class=" pending"><span class="fa fa-circle mr-1 "></span> {{rider.status}}</td>
                                <td>{{moment(rider.dateRegistered).format('DD/MM/YYYY')}} <span  @click="toggleList(rider)" class="relative fa fa-ellipsis-v ml-3 text-gray-500 cursor-pointer"></span>
                                <div>
                                    <ul class="absolute right-5 text-xs bg-gray-50  pt-4 pb-4 pl-2 pr-2" v-show="rider.navList">
                                        <router-link :to="{name: 'riders-info', params: {id: rider.email}}">
                                            <li class="border-b-2 cursor-pointer">View Information</li>
                                        </router-link> 
                                        <router-link :to="{name: 'email-center', params: {id:rider.email}}">   
                                            <li class="mt-2 border-b-2  cursor-pointer">Message</li>
                                        </router-link>
                                        <li class="mt-2 border-b-2  cursor-pointer" @click="approveRider(rider)">Approve Carrier</li>
                                        <li class="mt-2 border-b-2 cursor-pointer" @click="deleteRiderModal(rider)" >Delete Carrier</li>
                                    </ul>
                                </div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="!searchQuery " class="flex justify-between mt-10 text-gray-500 md:flex-col">
                    <div>
                        <p>Showing {{currentPage}} of {{totalPages}} Pages of {{totalList}} Carriers </p>
                    </div>

                    <div class="flex">
                        <button @click="prev" class="border w-24 text-center text-blue-600  border-blue-600"> <i class="fa fa-angle-left mr-2"></i>Previous </button>
                        <button @click="next" class="border w-24 text-center border-blue-600 text-blue-600 ml-1">Next <i class="fa fa-angle-right ml-2"></i></button>
                    </div>
                </div>
            </section>    
        </div>

        <div>
            <DeleteModal
            v-show="deleteModal"
            @close="closeModal"
            :message="message"
            @getRiders="getRiders"
            :riderId="riderId"
            />
        </div>
    </section>
</template>

<script>
import AdminDashboardNav from '../AdminDashboardNav.vue';
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import axios from 'axios';
import moment from 'moment';
import DeleteModal from './DeleteModal.vue';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    components: {
        AdminDashboardNav,
        GetDate,
        Notification,
        DeleteModal
    },

    data() {
        return {
            navList: null,
            pendingRiderInfo:false,
            pendingRiders: true,
            filter: '',
            isLoading: false,
            riders: [],
            page: 1,
            status : "approved",
            pending: [],
            search: null,
            selectedName: null,
            showFilter: true,
            searchQuery : '',
            deleteStatus: 'deleted',
            currentList: "",
            totalList: "",
            deleteModal:false,
            message: "",
            riderId: "",
            currentPage:1,
            pageSize:20,
            searchLength: "",
            totalPages: "",
        }
    },

    computed: {
        
            filterName() {
            const query = this.searchQuery.toLowerCase()
            if(this.searchQuery) {
               return this.pending.filter((theOrder) => {  
                     return Object.values(theOrder).some((word) => String(word).toLowerCase().includes(query))
                })
            }  else {
                return this.pending.filter((row, index) => {
                let start = (this.currentPage -1)*this.pageSize;
                let end = this.currentPage*this.pageSize;
                let totalPages = this.pending.length / this.pageSize
                this.totalPages = Math.round(totalPages)
                if(this.totalPages == 0) {
                    this.totalPages = 1
                }
                if(index >= start && index < end) return true;
                })
            }
        }
       
    },

    mounted() {
        this.getRiders();
        this.networkError();
    },

    methods: {
        moment(date) {
            return moment(date);
        },

        showDetails(eachUser) {
            this.selectedName = eachUser;
            this.showFilter = false
            this.getRiders()
        },

         closeModal() {
            this.deleteModal = false;
        },
        deleteRiderModal(rider) {
            this.riderId = rider.riderId
            rider.navList = !rider.navList
            this.deleteModal = true;
            this.message =  "Are you sure you want to perform this action?"
        },

        goBack() {
            this.$router.go(-1)
        },

        next() {
            if((this.currentPage*this.pageSize) < this.pending.length) this.currentPage++;
        },

        prev() {
            if(this.currentPage > 1) this.currentPage--
        },

        toggleList(rider) {
            rider.navList = !rider.navList
        },

        approveRider(rider) {
            rider.navList = !rider.navList
            axios({
                method: 'PUT',
                url: `${url}/v1/web/riders/update/status/${rider.riderId}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem('token'),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.status
                }
            })
            .then((response) => {
                this.getRiders()
                response
            }) 
            .catch((error) => {
                console.log(error)
            })
        },
        

        getRiders() {
            this.isLoading = true
            axios({
                method: 'GET',
                url: `${url}/v1/web/riders?&status=pending`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                this.isLoading = false;
                this.pending = response.data.data.results;
                this.currentList = this.pending.length;
                this.totalList = response.data.data.meta.totalResults;
            })
            .catch((error) => {
                console.log(error)
            })
            
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>

<style scoped>
.pending {
    color: rgb(243, 243, 9);
}
</style>